(function () {
  // 1回だけリロードするためのフラグ
  const KEY = "vo_cart_fix_reload_once";

  // リロード後の初回表示ではフラグを消して終了（無限ループ防止）
  if (sessionStorage.getItem(KEY) === "1") {
    sessionStorage.removeItem(KEY);
    return;
  }

  function shouldTrigger(url) {
    if (!url) return false;
    // 削除・数量変更・更新のどれでも「表示ズレ」が起きうるので広めに拾う
    return (
      url.includes("/cart/change") ||
      url.includes("/cart/update") ||
      url.includes("/cart/add")
    );
  }

  function triggerReload() {
    // 連続発火防止
    if (sessionStorage.getItem(KEY) === "1") return;
    sessionStorage.setItem(KEY, "1");
    setTimeout(function () {
      window.location.reload();
    }, 300);
  }

  // fetch をフック
  const _fetch = window.fetch;
  if (typeof _fetch === "function") {
    window.fetch = async function (...args) {
      const res = await _fetch.apply(this, args);
      try {
        const url = typeof args[0] === "string" ? args[0] : args[0] && args[0].url;
        if (res && res.ok && shouldTrigger(url)) {
          triggerReload();
        }
      } catch (e) {}
      return res;
    };
  }

  // XHR をフック（テーマによってはこっち）
  const _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__vo_cart_fix_url = url;
    return _open.call(this, method, url, ...rest);
  };

  const _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (...args) {
    this.addEventListener("load", function () {
      try {
        if (this.status >= 200 && this.status < 300 && shouldTrigger(this.__vo_cart_fix_url)) {
          triggerReload();
        }
      } catch (e) {}
    });
    return _send.apply(this, args);
  };
})();
